<template>
  <div class="form-group">
    <label class="mb-1">{{ $t('applicationWindow.playerTags') }}</label>
    <multiselect
      v-model="selected"
      :options="options"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      label="name"
      track-by="uuid"
      :placeholder="$tc('playerTag.name', 2)"
    >
      <template slot="option" slot-scope="{ option }">
        <span>{{ option.name }}</span>
        <span v-if="option.is_public" class="badge badge-info ml-1">{{ $t('playerTag.public') }}</span>
      </template>
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="multiselect__tag" :style="tagStyle(option)">
          <span>{{ option.name }}</span>
          <i class="multiselect__tag-icon" @click.prevent="remove(option)"></i>
        </span>
      </template>
    </multiselect>
    <small class="form-text text-muted">{{ $t('applicationWindow.playerTagsHint') }}</small>
    <span v-if="errorMessage" class="help-block form-text text-danger">{{ errorMessage }}</span>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import PlayerTagService from '@/services/playerTag.service'

/**
 * Tags a submitter can choose from in the team application form of the window (v-model = tag uuids).
 */
export default {
  components: { Multiselect },
  props: {
    value: { type: Array, default: () => [] },
    errors: { type: Object, default: null }
  },
  data () {
    return {
      options: []
    }
  },
  computed: {
    selected: {
      get () {
        return this.options.filter(tag => this.value.includes(tag.uuid))
      },
      set (tags) {
        this.$emit('input', tags.map(tag => tag.uuid))
      }
    },
    errorMessage () {
      const errors = this.errors && this.errors.playerTagUuids
      if (!errors) return null
      const first = Array.isArray(errors) ? errors[0] : errors[Object.keys(errors)[0]]
      if (typeof first !== 'string') return null
      if (first.includes(' ')) return first
      return this.$t('validation.playerTagUuids.' + first.split('.').pop().split('|')[0])
    }
  },
  created () {
    PlayerTagService.index().then((res) => {
      this.options = res.data
    })
  },
  methods: {
    tagStyle (tag) {
      return tag && tag.color ? { backgroundColor: tag.color, color: '#fff' } : {}
    }
  }
}
</script>
